export default "__VITE_ASSET__BlohxevZ__"